import { HStack, Image } from '@chakra-ui/react'
import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import formatPhoneNumber from '@core/utils/helpers/formatPhoneNumber'
import getAddressStringFromObject from '@core/utils/helpers/getAddressStringFromObject'
import type { FlagOption } from '@core/components/FlagSelect/FlagSelect'
import useFormattedDatesPeriod from '@core/utils/hooks/useFormattedDatesPeriod'
import useGetGenderString from '@core/utils/hooks/useGetGenderString'
import React from 'react'
import { prefixes } from '@core/utils/helpers/prefixes'
import './ApplyV2ReviewApplyProfile.scss'

interface ApplyV2ReviewApplyProfileProps {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyProfile'

function ApplyV2ReviewApplyProfile({ className = '' }: ApplyV2ReviewApplyProfileProps) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const { formatDateRange, formatDuration } = useFormattedDatesPeriod()

    const profileData = postProfileData?.data?.profile

    const getFlagPath = (prefixes: FlagOption[]) => {
        return prefixes.find(
            (obj) =>
                obj.prefix === profileData?.mobilePhone?.prefix || obj.prefix === `+${profileData?.mobilePhone?.prefix}`
        )?.code
    }

    const flagPath = getFlagPath(prefixes)

    return (
        <div className={`${baseClass} ${className}`}>
            {profileData?.firstName && <ApplyV2DataRow title={'First name'}>{profileData?.firstName}</ApplyV2DataRow>}
            {profileData?.lastName && <ApplyV2DataRow title={'Last name'}>{profileData?.lastName}</ApplyV2DataRow>}
            {profileData?.email && (
                <ApplyV2DataRow title={'Email'} fieldType={'email'}>
                    {profileData?.email}
                </ApplyV2DataRow>
            )}
            {profileData?.linkedin && (
                <ApplyV2DataRow title={'LinkedIn profile link'} fieldType={'link'}>
                    {profileData?.linkedin}
                </ApplyV2DataRow>
            )}
            {profileData?.mobilePhone && (
                <ApplyV2DataRow title={'Mobile phone'} fieldType={'mobilePhone'}>
                    <HStack>
                        {prefixes && profileData?.mobilePhone?.prefix && flagPath && (
                            <Image
                                maxW={4}
                                src={`${
                                    process.env.ENV === 'local' ? process.env.API_URL : window.location.origin
                                }/${flagPath}`}
                                alt={profileData?.mobilePhone?.prefix}
                            />
                        )}
                        <span>{formatPhoneNumber(profileData?.mobilePhone)}</span>
                    </HStack>
                </ApplyV2DataRow>
            )}
            {profileData?.gender && profileData?.gender > 0 && (
                <ApplyV2DataRow title={'Gender'} fieldType={'gender'}>
                    {useGetGenderString(profileData?.gender)}
                </ApplyV2DataRow>
            )}
            {profileData?.dateOfBirth && (
                <ApplyV2DataRow title={'Date of birth'} fieldType={'birthdate'}>
                    {/*{profileData?.dateOfBirth}*/}
                    {formatDateRange(profileData?.dateOfBirth, null, {
                        isShowPresent: false,
                        dateFormat: 'D MMMM YYYY',
                    })}
                </ApplyV2DataRow>
            )}
            {getAddressStringFromObject(profileData?.address) && (
                <ApplyV2DataRow title={'Location'} fieldType={'location'}>
                    {getAddressStringFromObject(profileData?.address)}
                </ApplyV2DataRow>
            )}
        </div>
    )
}

export default ApplyV2ReviewApplyProfile
